import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import moment from "moment";

function ParticipantTable(props) {
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const { data } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };
  return (
    <>
      {" "}
      <div className="col-md-12 col-lg-6 mb-3">
        <h5 className="head-line text-warning card-bg p-2">Participate List</h5>

        <div className="tr-odd-wallet">
          <table className="table w-100">
            <thead className="bg-warning">
              <tr>
                <th scope="col" className="text-black fw-bold">
                  #
                </th>
                <th scope="col" className="text-black fw-bold">
                  Name
                </th>
                <th scope="col" className="text-black fw-bold">
                  Email
                </th>
                <th scope="col" className="text-black fw-bold">
                  Register Date
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems &&
                currentItems?.participant?.map((postDetails, index) => (
                  <tr className="tr-child-wallet" key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      {postDetails?.participant?.first_name +
                        " " +
                        postDetails?.participant?.last_name}
                    </td>
                    <td>{postDetails?.participant?.email}</td>
                    <td> {moment(postDetails?.created_at).format("LL")}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <div id="react-paginate">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
}

export default ParticipantTable;
